/**
 * @memberof SMART2
 * @ngdoc directive
 * @name Character-restrict
 * @description This directive is useful for preventing character from entering in text field .
 * 
 * @attr {String} patternreg
 *    Js Regex pattern need to be entered
 * 
 * @example
 Dynamic: 
  Usage:
      <smart-textfield model-data="config.modelData" smart-character-restrict pattern="[^\w\s-()]"></smart-form-widget>
 */

(function (angular) {
    'use strict';
    angular.module('SMART2').directive('smartCharacterRestrict', function () {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var keyCheckRe = new RegExp(attrs.patternreg, 'ig'),
                    valueCheckRe = attrs.validationreg ? new RegExp(attrs.validationreg, 'ig') : false,
                    valueRegexPassed,
                    allowCharacterFlag = attrs.allowpaste;

                element
                    .off('keypress.smartcharacterrestrict')
                    .on('keypress.smartcharacterrestrict', 'input', function (inputValue) {
                        keyCheckRe.compile(attrs.patternreg, 'ig');
                        if (inputValue.key == null) {
                            return ''
                        }

                        if (keyCheckRe.test(inputValue.key)) {
                            inputValue.preventDefault();
                        }

                        if (valueCheckRe) {
                            valueCheckRe.compile(attrs.validationreg, 'ig');
                            valueRegexPassed = valueCheckRe.test(inputValue.target.value + inputValue.key)
                            if (valueRegexPassed == false) {
                                inputValue.preventDefault();
                            }
                        }
                    });

                element
                    .off('paste.smartcharacterrestrict')
                    .on('paste.smartcharacterrestrict', 'input', function (inputValue) {
                        if (allowCharacterFlag === 'true') {

                        } else {
                            return false;
                        }

                    });
            }
        }
    });
})(angular);